/*******
* js file for Search/Filter forms
*
********/

// Search form in header/footer
var site_search_form = $('.page-header .search-form');
var site_search_trigger = site_search_form.find('.action');
site_search_trigger.click(function(e){
	if( site_search_form.hasClass('open') ){
		//alert('its open');
	}else{
		e.preventDefault();
		site_search_form.find('fieldset').animate({'width':'200px'});
		site_search_form.addClass('open')
	}
});


// Browse/filter forms

var advanced_search_form = $('.advanced-search-form');
//var checkbox_dropdown = $('.apply-dropdown');
var checkbox_dropdown = advanced_search_form.find('.field.optionset, .field.checkboxset');
var trigger = checkbox_dropdown.find('label.left');

trigger.click(function(){
	$(this).closest(checkbox_dropdown).toggleClass('open');
	$(this).next().removeClass('hide');
});

// $('label:not(.left), input').on('click', function () {
	
// 	$(this).closest(checkbox_dropdown).parent().addClass('hide');
// 	$(trigger).closest(checkbox_dropdown).removeClass('open');
// 	//$('.open').toggleClass();

// });

/**
 * Search functionality
 **/

$(document).ready( function() {
    
	UpdateSearchForm();
	
	$(document).on('change', '.advanced-search-form input, .advanced-search-form select', function(event){
		UpdateSearchForm( event );
	});
	
});


/**
 * Re-assess the search form and refresh the UI
 * This is typically triggered on page load and when the form changes
 * @param event = change event when field changed
 **/
function UpdateSearchForm( event ){
	
	var target = false;
	if( typeof(event) !== 'undefined' && $(event.target) ) target = $(event.target);
	var form = $(document).find('.advanced-search-form');
			
	// if we're updating as part of a 'change' event
	if( target ){
		var inputs = target.closest('.field.checkboxset').find('input[type="checkbox"]');
		
		// clicked the 'all' item, so uncheck everything else
		if( target.is('[value="all"]') ){	
			inputs.filter(':not([value="all"])').prop('checked', false);
			
		// unchecked a normal item, and now nothing is selected, so select 'all'
		}else if( inputs.filter(':checked').length <= 0 ){
			inputs.filter('[value="all"]').prop('checked', true);
			
		// toggled a normal item, so uncheck 'all' if not already
		}else{
			inputs.filter('[value="all"]').prop('checked', false);
		}
	
	// no target, so this is our initial load
	}else{
	
		// loop all of the checkboxes
		form.find('.field.checkboxset').each( function(eq, field){
			
			var field = $(field);
			var inputs = field.find('input[type="checkbox"]');
			
			// if nothing is selected, select the 'all' item
			if( inputs.filter(':not([value="all"]):checked').length <= 0 ){
				inputs.filter('[value="all"]').prop('checked', true);
			}
		});
	}
}